'use client';

import { Card } from '@/components/ui';
import { ScrollableContainer } from '../common/scrollable-container';

export interface CoefficientResult {
  cv: number;
  mean: number;
  standardDeviation: number;
  data: number[];
}

interface CoefficientCalculatorProps {
  visualizationData: CoefficientResult | null;
}

export function CoefficientCalculator({ visualizationData: result }: CoefficientCalculatorProps) {
  if (!result) {
    return null;
  }

  const { cv, mean, standardDeviation } = result;

  return (
    <ScrollableContainer>
      <div className="space-y-6">
        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Coefficient of variation results</h3>
          <div className="space-y-4">
            <div>
              <p className="font-medium">Coefficient of variation (CV):</p>
              <p>{cv.toFixed(2)}%</p>
            </div>
            <div>
              <p className="font-medium">Mean:</p>
              <p>{mean.toFixed(4)}</p>
            </div>
            <div>
              <p className="font-medium">Standard deviation:</p>
              <p>{standardDeviation.toFixed(4)}</p>
            </div>
            <div>
              <p className="font-medium">Interpretation:</p>
              <p>
                {cv < 15
                  ? 'Low variability (CV < 15%)'
                  : cv < 35
                  ? 'Moderate variability (15% ≤ CV < 35%)'
                  : 'High variability (CV ≥ 35%)'}
              </p>
            </div>
          </div>
        </Card>
      </div>
    </ScrollableContainer>
  );
} 